import RouterLink from 'components/navigation/RouterLink';
import { Link } from 'types/navigation';

type Props = {
  links: Link[];
  isAtBottom?: boolean;
  onMenuItemClick: () => void;
  isMenuOpen: boolean;
  isCenterNav?: boolean;
};

const cx = (...classes: Array<string | false | null | undefined>) => classes.filter(Boolean).join(' ');

function NavigationGroup({ links, isAtBottom, onMenuItemClick, isMenuOpen }: Props) {
  const onNavItemClick = () => onMenuItemClick();

  return (
    <div
      className={cx('mt-5 flex flex-col gap-2', isMenuOpen ? 'mx-2' : 'mx-0', isAtBottom && 'mt-auto mb-3')}
      onClick={onNavItemClick}
    >
      {links.map(({ to, text, icon, isActive }, i) => (
        <RouterLink to={to} key={i}>
          <div className="w-full">
            <div
              className={cx(
                'flex h-12 items-center rounded-full text-white hover:bg-white/20',
                'px-3',
                isActive && 'bg-white/30',
                !isMenuOpen && 'mx-auto w-fit justify-center px-0',
                isMenuOpen && 'justify-start gap-3',
              )}
            >
              <span className="grid shrink place-items-center">{icon}</span>

              {isMenuOpen && <p className="font-light">{text}</p>}
            </div>
          </div>
        </RouterLink>
      ))}
    </div>
  );
}

export default NavigationGroup;
